<template>
  <transition mode="out-in" name="fade-long">
    <div :class="{ 'ui-block--solid': props.solid }" class="ui-block" ref="root" v-show="props.value">
      <div class="ui-block__overlay"/>
      <div class="ui-block__loader">
        <div class="spinner-border" role="status"/>
      </div>
    </div>
  </transition>
</template>

<script setup>
  const props = defineProps({
    value: {
      type: Boolean,
      default: false,
    },
    solid: {
      type: Boolean,
      default: false,
    },
  });
</script>
